import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const scaleway = defineConnector({
  identifier: "scaleway",
  name: "Scaleway",
  tagLine: "European cloud services provider",
  logo,
  protocol: "http",
  tags: ["it", "engineering"],
  defaultUrlPattern: () => "https://api\\.scaleway\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "X-Auth-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [IAM > API keys](https://console.scaleway.com/iam/api-keys) in the Scaleway console and generate a new API key, then copy its secret key.",
        },
      ],
    },
    {
      title: "Copy and paste the secret key into the field below",
      items: [
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.scaleway.com/instance/v1/zones/fr-par-1/servers",
  },
});
